import './style.sass';

import FullWrapper from 'core/FullWrapper';

import CrewContainer from '~/components/features/cases/NextComponents/cases/moscow-exchange/team/crew-container';

type CrewItemType = {
    crewItemTitle: string;
    crewItemSubtitle?: string;
};
export type CrewListPropsType = {
    crewList: CrewItemType[];
};

const Team = ({ crewList }: CrewListPropsType) => (
    <div className="moscowExchange-team">
        <FullWrapper>
            <div className="moscowExchange-team__Title">Команда</div>
            <CrewContainer crewList={crewList} />
        </FullWrapper>
    </div>
);

export default Team;
